import { useEffect } from "react";
import {NavTopMainEn} from "../components/navTop";
import {
    BannerEn,
    HeaderBanner,
    // BannerDouble,
    // PublicNews,
} from "../components/banners";
// import BannerCarousel, { SubCarousel } from "../components/bannerCarousel";
// import BoardActivities from "../components/board_activities";
import Activities from "../components/activities";
// import PartnerBanners from "../components/partners";
import {PageFooterEn} from "../components/footer";

import AOS from "aos";
import "aos/dist/aos.css";

export default function App() {
    // const [bannerHeader, setBannerHeader] = useState([]);

    useEffect(() => {
        // const fetchData = async () => {
        //     try {
        //     } catch (e) {
        //         console.error("Error: ", e);
        //     }
        // };
        // fetchData();

        AOS.init();
        // eslint-disable-next-line
    }, []);
    return (
        <>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder">
                <HeaderBanner />
                <NavTopMainEn />
                <section id="mainContent">
                    <BannerEn />
                    {/* <BannerCarousel /> */}
                    {/* <BannerDouble /> */}
                    {/* <SubCarousel name="carouselAct" /> */}
                    {/* <PublicNews /> */}
                </section>
            </div>
            {/* <BoardActivities /> */}
            <Activities />
            {/* <PartnerBanners /> */}
            <PageFooterEn />
        </>
    );
}
